import type { EditorCommand } from '@atlaskit/editor-common/types';
import type { AiManagedObject } from '@atlassian/ai-managed-objects/types';

import {
	type AgentManagedExtensionMeta,
	type AgentManagedExtensionMetaAction,
	setMeta,
} from '../pm-plugins/state';

const dispatchMeta =
	(meta: AgentManagedExtensionMeta): EditorCommand =>
	({ tr }) => {
		setMeta(tr, meta);
		tr.setMeta('addToHistory', false);
		return tr;
	};

/** Open the inline configuration popup for the agent-managed block at the current selection. */
export const openConfig = (): EditorCommand => dispatchMeta({ type: 'OPEN_CONFIG' });

/** Close the inline configuration popup. */
export const closeConfig = (): EditorCommand => dispatchMeta({ type: 'CLOSE_CONFIG' });

/** Toggle the inline configuration popup. */
export const toggleConfig = (): EditorCommand => dispatchMeta({ type: 'TOGGLE_CONFIG' });

export const getCacheAiManagedObjectMeta = (
	aiManagedObject: AiManagedObject,
	localId?: string,
): AgentManagedExtensionMetaAction => ({
	aiManagedObject,
	localId,
	type: 'CACHE_AI_MANAGED_OBJECT',
});

/** Cache a full AI-managed object in plugin state. */
export const cacheAiManagedObject = (
	aiManagedObject: AiManagedObject,
	localId?: string,
): EditorCommand => dispatchMeta(getCacheAiManagedObjectMeta(aiManagedObject, localId));
